import { combineReducers } from "@reduxjs/toolkit";

import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";

import AccountReducer from "./statics/accounts/reducer";
import TagsReducer from "./statics/tags/reducer";
import CompaniesReducer from "./statics/companies/reducer";
import PersonsReducer from "./statics/persons/reducer";
import CategoriesReducer from "./statics/categories/reducer";
import ProjectsReducer from "./statics/projects/reducer";
import ProjectTypesReducer from "./statics/project_types/reducer";

import FilterdataReducer from "./filters/reducer";
import NotificationsReducer from "./notifications/reducer";

const rootReducer = combineReducers ({
    Login: LoginReducer,
    Account: AccountReducer,
    Profile: ProfileReducer,
    ForgetPassword: ForgetPasswordReducer,
    Tags: TagsReducer,
    Companies: CompaniesReducer,
    Persons: PersonsReducer,
    Categories: CategoriesReducer,
    Projects: ProjectsReducer,
    ProjectTypes: ProjectTypesReducer,
    Filterdata: FilterdataReducer,
    Notifications: NotificationsReducer,
});

export default rootReducer
